import type { ReactNode } from "react";

export function SectionLabel({ children }: { children: ReactNode }) {
  return (
    <h2
      style={{
        fontSize: 10,
        fontWeight: 600,
        letterSpacing: "0.08em",
        textTransform: "lowercase",
        color: "var(--fg-3)",
        margin: "0 0 10px",
        paddingBottom: 6,
        borderBottom: "1px solid var(--comp-rule)",
      }}
    >
      {children}
    </h2>
  );
}
